import _dottedPathToPopulation from '@/shared/functions/population-helpers/_dottedPathToPopulation';

/**
 * Generate standard tire population object for the given prefix
 *
 * @param path - The path to generate the population object for
 * @returns The population object
 *
 * @example
 * // Returns {
 * //   'populate[tire][brand]': 1,
 * //   'populate[tire][segment]': 1,
 * //   'populate[tire][certifiedBy]': 1,
 * //   'populate[tire][euTireLabel]': 1,
 * //   'populate[tire][tireCategory]': 1,
 * //   'populate[tire][featureandBenefit]': 1,
 * // }
 * standardTirePopulation('tire')
 */
export default function standardTirePopulation(
  path: string = '',
  {
    populateRoot = true,
  }: {
    populateRoot?: boolean;
  } = {}
) {
  const p = _dottedPathToPopulation(path);

  return {
    ...(populateRoot ? { [`populate${p}`]: 1 } : {}),
    [`populate${p}[brand]`]: 1,
    [`populate${p}[segment]`]: 1,
    [`populate${p}[certifiedBy]`]: 1,
    [`populate${p}[euTireLabel]`]: 1,
    [`populate${p}[tireCategory]`]: 1,
    [`populate${p}[featureandBenefit]`]: 1,
    [`populate${p}[technology]`]: 1,
    [`populate${p}[euTireLabel]`]: 1,
    [`populate${p}[pressTest]`]: 1,
    [`populate${p}[factbook]`]: 1,
  };
}
